import { MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import CountdownBanner from "areas/header/countdown-banner"
import stickyHeader from "areas/header/hoc/sticky-header"

import DesktopNav from "./desktop-nav"
import MobileHeader from "./mobile-header"

const DesktopHeaderContainer = styled(MediaBox).attrs((props) => ({
  bg: "white",
  borderBottom: `1px solid ${props.theme.colors.grey[10]}`,
  boxShadow: props.sticky ? "0 6px 10px -6px #bdbdbd" : "none",
  greaterThanOrEqual: "desktop",
}))`
  transition: box-shadow 0.4s;
`

const HeaderContent = ({
  microbanner,
  secondMicroBanner,
  secondMicroBannerExp,
  sticky,
}) => {
  return (
    <>
      <CountdownBanner
        microbanner={microbanner}
        secondMicroBannerExp={secondMicroBannerExp}
      />
      <MobileHeader sticky={sticky} />
      <DesktopHeaderContainer sticky={sticky}>
        <DesktopNav />
      </DesktopHeaderContainer>
      {secondMicroBannerExp === 1 && secondMicroBanner && (
        <CountdownBanner
          isSecondMicroBanner
          microbanner={secondMicroBanner}
          secondMicroBannerExp={secondMicroBannerExp}
        />
      )}
    </>
  )
}

HeaderContent.propTypes = {
  microbanner: PropTypes.object,
  secondMicroBanner: PropTypes.object,
  secondMicroBannerExp: PropTypes.number,
  sticky: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    microbanner: state.sale.microbanner,
    secondMicroBanner: state.sale.second_microbanner,
    secondMicroBannerExp: state.experiment.secondMicroBanner.variant_id,
  }
}

export default connect(mapStateToProps)(stickyHeader(HeaderContent))
